
const $ = require('jquery');


const NOTHING_RE = 'a^'; // regex that can't match anything

const PRESETS = {
	'titlecase': {
		// NOTE: Don't use "()" groups here, only non-capturing "(?:...)", if you really need them
		alphabet: '[a-zа-яё]', // Set of letters affected by transformation
		capitalizeAfter: '(?:^|[ ])', // Letters following this regex will be capitalized
		preserveAfter: '[-]', // Letters following this regex will not be changed
		lowerAfter: '.', // Letters following this regex will be lowered
		// Other letters will not be changed
	},
	'uppercase': {
		alphabet: '[a-zа-яё]',
		capitalizeAfter: '(?:^|.)',
		preserveAfter: NOTHING_RE,
		lowerAfter: NOTHING_RE,
	},
};

$.fn.inputcapitalize = function (options) {
	/*
	 * Forces input value to be formatted in "Title Case" (every word starts
	 * with a capital letter)
	 *
	 * See `options' explanation below
	 */

	if ('string' === typeof options) {
		options = PRESETS[options];
	}

	options = $.extend({}, PRESETS.titlecase, options);

	const letterRe = new RegExp(options.alphabet, 'ig');

	let capitalizeAfterRe = new RegExp('^' + options.capitalizeAfter + '$'),
		preserveAfterRe = new RegExp('^' + options.preserveAfter + '$'),
		lowerAfterRe = new RegExp('^' + options.lowerAfter + '$');

	const handler = function (event) {
		if (event.keyCode && (event.keyCode >= 37 && event.keyCode <= 40)) {
			return;
		}

		const $this = $(this);

		const value = $this.val();
		const formatted = value.replace(letterRe, function (letter, offset) {
			const indexBeforeLetter = Math.max(0, offset - 1);
			const beforeLetter = value.slice(indexBeforeLetter, offset);

			let replacement = null;
			if (capitalizeAfterRe.test(beforeLetter)) {
				replacement = letter.toUpperCase();
			} else if (preserveAfterRe.test(beforeLetter)) {
				// noop
			} else if (lowerAfterRe.test(beforeLetter)){
				replacement = letter.toLowerCase();
			}
			return replacement || letter;
		});

		if (value == formatted) {
			return;
		}

		const oldCursor = this.selectionStart || value.length;
		$this.val(formatted).change();
		this.selectionStart = this.selectionEnd = oldCursor; // restore cursor position
	};
	$(this).on('input onchange', handler);
};

module.exports = $.fn.inputcapitalize;


